import script from './ClickableRouterLink.vue2.js';
import normalizeComponent from '../../../node_modules/vue-runtime-helpers/dist/normalize-component.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("RouterLink", {
    attrs: { to: _vm.computedTo, custom: "" },
    on: { click: _vm.emitClick },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function(ref) {
            var href = ref.href;
            var navigate = ref.navigate;
            return [
              _c(
                "a",
                {
                  attrs: { href: _vm.to ? href : undefined },
                  on: {
                    click: function($event) {
                      return _vm.handleClick($event, navigate)
                    }
                  }
                },
                [_vm._t("default")],
                2
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as default };
